@if (showMixitX509WarningBanner$ | async) {
  <gbc-banner type="info" class="mt-8">
    <img src="./assets/svgs/list-commissioning.svg" />
    <div [innerHTML]="message"></div>
  </gbc-banner>
}
